<template>
  <div>
    <CustomersClub />
  </div>
</template>

<script>
import appConfig from '@/app.config'
import CustomersClub from '../../../components/skillup/customersClub/CustomersClub.vue'

export default {
  page: {
    title: 'باشگاه مشتریان',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillup-customers-club',
  components: { CustomersClub },
}
</script>
